// extracted by mini-css-extract-plugin
export default {"container":"cP_d","checkbox":"cP_kV","isActive":"cP_f2","checkboxIcon":"cP_kW","text":"cP_c2"};